import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import RoadTransport from "../Service/RoadTransport/RoadTransport";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const UserTab = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // console.log(newValue);
  };
  return (
    <div className="oder-details">
      <Paper className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Draft" className="tab" />
          <Tab label="Open" className="tab" />
          <Tab label="In Progress" className="tab" />
          <Tab label="Closed" className="tab" />
        </Tabs>
      </Paper>

      <RoadTransport value={value} />
    </div>
  );
};

export default UserTab;
